import React, { useEffect } from "react";
import * as Sentry from "@sentry/react";
import { useExponea } from "../../../../utils/useExponea";
import { env } from "build/env";
import { useWindowSize } from "@overrides_venia/peregrine/hooks/useWindowSize";
import { isOrderActive } from "@Components/LinkBetween/miScusiAndTakeAwayUtils";
import classes from "./weglotInit.module.scss";
var WeglotInit = () => {
  var {
    trackEvent
  } = useExponea();
  var {
    isMobile
  } = useWindowSize();
  var triggerSelector = document.querySelector(".weglotInit");
  var weglotSelector = document.querySelector(".weglot_switcher");
  useEffect(() => {
    if (weglotSelector) {
      window.addEventListener("scroll", () => {
        if (weglotSelector && window.scrollY) weglotSelector.classList.add("inactiveNav");else if (weglotSelector && !window.scrollY) weglotSelector.classList.remove("inactiveNav");
      });
    }
  }, [document.querySelector(".weglot_switcher")]);
  useEffect(() => {
    if (env.WEGLOT_API_KEY && triggerSelector) {
      loadWeglot(() => {
        Weglot.initialize({
          api_key: env.WEGLOT_API_KEY,
          cache: false,
          switchers: [{
            location: {
              target: isMobile && !isOrderActive ? ".weglotInit" : null,
              sibling: null
            }
          }]
        });
        Weglot.on("languageChanged", function (newLang, prevLang) {
          Sentry.setTag("weglotLanguage", newLang);
          Sentry.addBreadcrumb({
            category: "weglot",
            message: "Language changed: " + prevLang + " to " + newLang,
            level: "info"
          });
          trackEvent("language_changed", {
            new_language: newLang,
            previous_language: prevLang
          });
        });
      });
    }
  }, [document.querySelector(".weglotInit")]);
  return /*#__PURE__*/React.createElement("div", {
    className: "weglotInit ".concat(!isOrderActive ? classes.local : "", " ").concat(isMobile ? classes.mobile : classes.desktop, " ").concat(classes.weglotInit)
  });
};
export function resetWeglot() {
  var weglotSelector = document.querySelector(".weglot_switcher");
  var weglotSelectorNew = weglotSelector && weglotSelector.cloneNode(true);
  if (weglotSelectorNew) {
    weglotSelector.parentNode.replaceChild(weglotSelectorNew, weglotSelector);
    weglotSelector.classList.remove("headerWeglot");
  }
}
var loadWeglot = callback => {
  var existingScript = document.getElementById("weglotJS");
  if (!existingScript) {
    var script = document.createElement("script");
    script.src = "https://cdn.weglot.com/weglot.min.js";
    script.async = true;
    script.id = "weglotJS";
    script.onload = () => {
      if (callback) callback();
    };
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }
};
export default WeglotInit;